module.exports = __webpack_public_path__ + "img/image 2422.f0ef15ab.png";